import igv from "@/assets/js/igv.min.js"

export default {

    async initializeIGVBrowser(igvContainer,active_chrom,vcf=null) {
            //alert(this.active_chrom)
            //this.active_chrom = "chr8:127,736,588-127,739,371"
            const igvOptions = {
                genome: "hg38",
                locus: active_chrom,
                tracks: [
                ],
                color: "#f5f5f5"
            }

            if (vcf != null) {
                igvOptions.tracks.push(
                    {
                        type: 'variant',
                        format: 'VCF',
                        url: vcf,
                        indexed: false,
                        height: 50,
                        displayMode: "EXPANDED",
                        sourceType: "file",
                        colorBy: "SVTYPE",
                        colorTable: {
                            "DEL": "#ff2101",
                            "INS": "#001888",
                            "DUP": "#028401",
                            "INV": "#008688",
                            "CNV": "#8931ff",
                            "BND": "#891100",
                            "*": "#002eff"
                         }
                    },
                )
            }

            igvOptions.tracks.push(
                    {
                        name: "Annotations",
                        format: "gff3",
                        displayMode: "expanded",
                        height: 150,
                        url: "https://s3.amazonaws.com/igv.org.genomes/hg38/Homo_sapiens.GRCh38.94.chr.gff3.gz",
                        indexURL: "https://s3.amazonaws.com/igv.org.genomes/hg38/Homo_sapiens.GRCh38.94.chr.gff3.gz.tbi",
                        visibilityWindow: 1000000,
                        color: (feature) => {
                            switch (feature.getAttributeValue("biotype")) {
                                case "antisense":
                                    //return "blueviolet"
                                    return "#f5f5f5"
                                case "protein_coding":
                                    return "blue"
                                case "retained_intron":
                                    return "rgb(0, 150, 150)"
                                case "processed_transcript":
                                    //return "purple"
                                    return "#f5f5f5"
                                case "processed_pseudogene":
                                    return "#7fff00"
                                case "unprocessed_pseudogene":
                                    return "#d2691e"
                                default:
                                    return "black"
                            }
                        }
                    },
                    /*{
                        name: "TranscriptsGENCODE",
                        type: "annotation",
                        format: "gtf",
                        displayMode: "expanded",
                        height: 300,
                        url: "http://localhost/gencode.v43.annotation.sorted.gtf.gz",
                        indexURL: "http://localhost/gencode.v43.annotation.sorted.gtf.gz.tbi",
                        visibilityWindow: 1000000,
                        colorBy: "biotype",
                        colorTable: {
                           "antisense": "#4d5862",
                           "protein_coding": "blue",
                           "retained_intron": "rgb(0, 150, 150)",
                           "processed_transcript": "#858585",
                           "processed_pseudogene": "#7fff00",
                           "unprocessed_pseudogene": "#d2691e",
                           "*": "black"
                        }
                    },*/

            )

            igv.createBrowser(igvContainer, igvOptions)
            .then((browser) => {
                console.log('IGV browser initialized')
            })
            .catch((error) => {
                console.error('Error initializing IGV browser '+error)
            })
    },
}
